export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('zh-CN');
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('zh-CN');
}

export const PROTOCOL_LABELS: Record<string, string> = {
  vmess: 'VMess',
  vless: 'VLESS',
  ss: 'Shadowsocks',
  trojan: 'Trojan',
  hysteria2: 'Hysteria2',
  tuic: 'TUIC',
  socks: 'SOCKS5',
  http: 'HTTP',
};
